import { AutogenLayoutFuelSurchargeCycleCodesMaster } from "./autogen/AutogenLayoutFuelSurchargeCycleCodesMaster";
import { DropdownSelectionEvent, DataDisplayEvent, DataHeader } from "@mcleod/components";

export class FuelSurchargeCycleCodesMaster extends AutogenLayoutFuelSurchargeCycleCodesMaster {

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.promptToSaveChanges();
    }

    /** This is an event handler for the afterDropdownSelection event of textboxCycleType. */
    textboxCycleTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        const selectedValue = event.selection?.value;
        if (event.userInitiatedChange && event.hasSelection()) {
            if (selectedValue === "W")
                this.setWeekdayOfMonthFields();
            else
                this.setDayOfMonthFields();
        }   
    }

    /** This is an event handler for the onDataDisplay event of textboxCycleType. */
    textboxCycleTypeOnDataDisplay(event: DataDisplayEvent) {
        if (event.rowData != null) {
            if (event.rowData?.get("cycle_type") === "W")
                this.setWeekdayOfMonthFields();
            else if (event.rowData?.get("cycle_type") === "D")
                this.setDayOfMonthFields();
            
        }
    }

    private setWeekdayOfMonthFields() {
        this.panelWeekdayofMonth.visible = true;
        this.panelDayofMonth.visible = false;
        this.textboxCalendarDay.text = "";
        this.textboxCalendarDay.required = false;
        this.textboxMonthFrequency.required = true;
        this.textboxWeekDay.required = true;
    }

    private setDayOfMonthFields() {
        this.panelWeekdayofMonth.visible = false;
        this.panelDayofMonth.visible = true;
        this.textboxCalendarDay.required = true;
        this.textboxMonthFrequency.required = false;
        this.textboxWeekDay.required = false;
        this.textboxMonthFrequency.text = "";
        this.textboxWeekDay.text = "";
    }

}
